import { Component, Input } from '@angular/core';
import { NbDialogRef, NbGlobalPhysicalPosition, NbIconConfig, NbToastrService } from '@nebular/theme';
import { GameService, LanguageService, MissionService } from '../../_services/index';

@Component({
    selector: 'app-import-open-mission',
    templateUrl: './import-open-mission.component.html',
    styleUrls: ['./import-open-mission.component.scss'],
    standalone: false
})

export class ImportOpenMissionTemplateComponent {

  @Input() missions;
  @Input() game;
  @Input() isTemplate;

  missionSelected = false
  positions = NbGlobalPhysicalPosition;
  loading = false;
  selectAll = false;
  selectedGameMission
  selectedOption
  missionImported = false
  openMissions = []
  stepperIndex: number = 0
  selectedMissions = []
  positionOpenMission = 0
  dataMissionToImport = []

  constructor(private languageService: LanguageService,
    protected ref: NbDialogRef<ImportOpenMissionTemplateComponent>,
    public missionService: MissionService,
    public gameService: GameService,
    private toastrService: NbToastrService) {
  }

  ngOnInit() {
    for (let i = 0; i < this.missions.length; i++) {
      if (!this.game.missions.find(mission => mission.id === this.missions[i].id))
      this.dataMissionToImport.push({
        mission:this.missions[i],
        checked:false,
        isDependentOn:false
      })
    }
  }

  checkSuccessMissionsDependece(event, successMissions){
    for (let i = 0; i < successMissions.length; i++) {
      let index = this.dataMissionToImport.findIndex((data)=>data.mission.id == successMissions[i])
      if(index >= 0) {
        this.dataMissionToImport[index].isDependentOn = event
      }
    }
  }

  checkFailedMissionsDependece(event, failMissions){
    for (let i = 0; i < failMissions.length; i++) {
      let index = this.dataMissionToImport.findIndex((data)=>data.mission.id == failMissions[i])
      if(index >= 0) {
        this.dataMissionToImport[index].isDependentOn = event
      }
    }
  }

  toggleMission(event, data){
    data.checked = event
    if(data.mission.successMissions.length > 0){
      this.checkSuccessMissionsDependece(event, data.mission.successMissions)
    }
    if(data.mission.failMissions.length > 0){
      this.checkFailedMissionsDependece(event, data.mission.failMissions)
    }
  }

  emptySelectedData() {
    delete this.selectedOption
    this.selectedGameMission = ''
    this.missionImported = false;
  }

  next() {
    this.stepperIndex += 1
  }

  toggleAll(checked: boolean) {
    for (let i = 0; i < this.dataMissionToImport.length; i++) {
      this.dataMissionToImport[i].checked = checked
      this.dataMissionToImport[i].isDependentOn = false
    }
    this.selectAll = checked
  }

  cancel() {
    this.ref.close();
  }

  showToast(type, status, text, iconName) {
    const icon: NbIconConfig = { icon: iconName, pack: 'eva' };
    let duration = 5000
    let position = this.positions.TOP_RIGHT
    this.toastrService.show(type, text, { position, status, duration, icon });
  }

  importMissionSelected() {
    this.missionSelected = true;
    this.selectedMissions = []
    for (let i = 0; i < this.dataMissionToImport.length; i++) {
      if(this.dataMissionToImport[i].checked){
        this.selectedMissions.push(this.dataMissionToImport[i].mission)
      }
    }
  }

  async import(openMission, i) {
    this.loading = true;
    this.positionOpenMission = this.selectedGameMission.orderNum + parseFloat(this.selectedOption)
    openMission.orderNum = this.positionOpenMission
    if(this.isTemplate){ 
      openMission.collectionPath = `game_templates/${this.game.id}/missions`
      this.game.missions.splice(this.positionOpenMission - 1, 0, openMission).join();
      await this.setSuccessFailMissions(openMission)
      this.updateMissionOrder(this.game.missions)
    } else {
      openMission.collectionPath = `games/${this.game.id}/missions`
      this.game.missions.splice(this.positionOpenMission - 1, 0, openMission).join();
      await this.setSuccessFailMissions(openMission)
      this.updateMissionOrder(this.game.missions)
    }
    if(i === (this.selectedMissions.length - 1)){
      await this.updateMissions(this.game.missions)
      this.cancel()
    }
  }

  setSuccessFailMissions(openMission){
    let data = this.dataMissionToImport.find(data => data.mission.id == openMission.id)
    if(data.mission.successMissions.length>0){
      let successMissions = [...data.mission.successMissions]
      for (let i = 0; i < successMissions.length; i++) {
        const id = successMissions[i];
        let dataSuccessMission = this.dataMissionToImport.find(data => data.mission.id == id)
        if(!dataSuccessMission.checked) {
          this.deletefeiledSuccessMissions(openMission, dataSuccessMission.mission.id,'successMissions')
        }
      }
    }
    if(data.mission.failMissions.length>0){
      let failMissions = [...data.mission.failMissions]
      for (let i = 0; i < failMissions.length; i++) {
        const id = failMissions[i];
        let dataFailMissions = this.dataMissionToImport.find(data => data.mission.id == id)
        if(!dataFailMissions.checked) {
          this.deletefeiledSuccessMissions(openMission, dataFailMissions.mission.id,'failMissions')
        }
      }
    }
  }
  deletefeiledSuccessMissions(openMission, id, att){
    let indexMission = this.game.missions.findIndex(mission => mission.id == openMission.id)
    let indexFeiledSuccessMission = this.game.missions[indexMission][att].findIndex(missionId => missionId == id)
    if (indexFeiledSuccessMission > -1) { 
      this.game.missions[indexMission][att].splice(indexFeiledSuccessMission, 1);
    }
  }

  setMission(mission){
    this.missionService.setMission(mission).then(res => {
      console.log('Create result:' + res);
      this.showToast('Success', 'success', `Mission ${mission.name[this.languageService.currentLang]} successfully added`, 'close-outline')
    }).catch(error => {
      console.log('error', error)
      this.loading = false;
      this.showToast('Error', 'danger', `Add Mission failed`, 'close-outline')
    });
  }

  updateMissionOrder(missions) {
    let i = 0;
    for (let mission of missions) {
      i++;
      if(mission.orderNum != i){
        mission.orderNum = i;
      }
      if (missions.length === i) {
        this.loading = false;
        this.missionImported = true;

        this.emptySelectedData()
        this.next()
      }
    }
  }

  updateMissions(missions){
    let i = 0;
    for (let mission of missions) {
      i++;
      this.isOpenMission(mission, this.missions)
      if (missions.length === i) {
        this.loading = false;
        this.missionImported = true;
      }
    }
  }

  isOpenMission(mission, missions){
    let finedMission = missions.find(openMission => openMission.id == mission.id)
    if(finedMission) {
      this.setMission(mission)
    }
    else this.missionService.updateMission(mission, {orderNum: mission.orderNum});
  }
}
